import React from 'react';
import './InfoItem.less';
import {InfoItemLabel} from "elements/info-item-label/InfoItemLabel";

export const InfoItem = ({label, control}) => {
	return <div className="info-item">
		<div className="info-item__label">
			<InfoItemLabel text={label}/>
		</div>
		<div className="info-item__control">{control}</div>
	</div>
}
